import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContext, useEffect, useRef } from 'react';
import { FileContext } from '../../../context/FileContext';
import { Resizable } from 're-resizable';

const LinkContainer = styled.div`
  .inner-container {
    line-height: 1.3;
    white-space: normal;
    word-wrap: break-word;
    font-family: 'Open Sans', sans-serif;
  }
  .content-class {
    white-space: pre-line;
  }
`;

const LinkEditOverlayChip = ({ item, setIsResizing, mondayBoardValues }) => {
  const { t } = useTranslation();

  const {
    columnValuesMap,
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
  } = useContext(FileContext);

  const currentRef = useRef(null);

  useEffect(() => {
    if (currentRef.current) {
      if (!item?.height) item.height = currentRef.current.clientHeight;
      if (!item?.width) item.width = currentRef.current.clientWidth + 3;
    }
  }, [item]);

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, _ref, d) => {
    setIsResizing(false);
    item.width = _ref.clientWidth;
    item.height = _ref.clientHeight;
    addedFormFields[currentSelectedItem.current] = item;
    updateFormFields([...addedFormFields]);
  };

  useEffect(() => {
    item.height = currentRef.current.clientHeight;
    const index = addedFormFields.findIndex((x) => x.id === item.id);
    if (index > -1) {
      addedFormFields[index] = item;
      updateFormFields([...addedFormFields]);
    }
  }, [item.fontSize]);

  const defaultWidth = 183.33;

  const updateItemURLData = (item) => {
    const index = addedFormFields.findIndex((x) => x.id === item.id);
    if (index > -1) {
      addedFormFields[index] = item;
      updateFormFields([...addedFormFields]);
    }
  };

  // if item doesnt have urldata then set url data, then add urlData
  useEffect(() => {
    if (!item.hasOwnProperty('urlData')) {
      item.urlData = columnValuesMap?.get(item?.itemId)?.value
        ? JSON.parse(columnValuesMap?.get(item?.itemId)?.value)
        : {
            url: '',
            text: '',
          };
      item.fontStyle.color = { r: 19, g: 130, b: 234 };
      updateItemURLData(item);
    }
  }, [item]);

  return (
    <>
      <LinkContainer fontSize={item.fontSize}>
        <Resizable
          enable={{
            top: false,
            right: item?.isActive,
            bottom: false,
            left: false,
            topRight: false,
            bottomRight: item?.isActive,
            bottomLeft: false,
            topLeft: false,
          }}
          onResizeStart={handleResizeStart}
          onResizeStop={handleResizeEnd(item)}
        >
          <div
            className="inner-container"
            style={{
              height: item.height || 'fit-content',
              overflowY: 'hidden',
              width: item.width || defaultWidth,
              maxWidth: 500,
            }}
            ref={currentRef}
          >
            <div className="content-class">
              {item.type === 'link'
                ? mondayBoardValues?.data?.items?.[0]?.column_values?.find(
                    (x) => x.id === item.itemId,
                  )?.text || t('Add Link Here')
                : item?.urlData?.text || t('Add Link Here')}
            </div>
          </div>
        </Resizable>
      </LinkContainer>
    </>
  );
};

export default LinkEditOverlayChip;
